/**
 * Helper
 */
var helper = require('../../helper'),
    dataTables_buttons = [

        {
            extend: 'csv',
            text: 'Export as CSV',
            exportOptions: {
                columns: '.data-export'
            },
            className: 'btn btn-default'
        },
        {
            extend: 'pdf',
            text: 'Export as PDF',
            exportOptions: {
                columns: '.data-export'
            },
            className: 'btn btn-default'
        },
        {
            extend: 'print',
            text: 'Print table',
            exportOptions: {
                columns: '.data-export'
            },
            className: 'btn btn-default'
        },
        {
            extend: 'colvis',
            className: 'btn btn-default'
        }

    ];

$(function () {
    var $datatable = $('#datatable-all-audit-log'),
        columns = [
            {data: 'user', name: 'user_id', searchable: false, className: 'data-export centerize'},
            {data: 'event_type', name: 'event', searchable: false, className: 'data-export centerize'},
            {data: 'model', name: 'auditable_type', searchable: false, className: 'data-export centerize'},
            {
                data: 'relatedTo',
                name: 'relatedTo',
                searchable: false,
                orderable: false,
                className: 'data-export centerize'
            },
            {data: 'old', name: 'old', orderable: false, searchable: false, className: 'data-export'},
            {data: 'new', name: 'new', orderable: false, searchable: false, className: 'data-export'},
            {data: 'url', name: 'url', searchable: false, className: 'data-export centerize'},
            {data: 'created_at', name: 'created_at', searchable: false, className: 'data-export centerize'},
        ], $dt;

    $dt = $datatable.DataTable({
        "dom": "<'dt-toolbar'lfB>tr<'row'<'col-sm-5'i><'col-sm-7'p>>",
        "buttons": dataTables_buttons,
        "processing": true,
        "serverSide": true,
        "responsive": true,
        "lengthMenu": [
            [30, 10, 25, 50, 75, 100],
            [30, 10, 25, 50, 75, 100]
        ],
        "ajax": {
            "url": helper.getOrigin() + "/api/audit-log",
            "method": 'POST',
            "data": function (d) {
                d.user_id = $('select[id=user_id]').val();
                d.event_name = $('select[id=event_name]').val();
                d.object_num = $('select[id=object_num]').val();
                d.object_id = $('input[id=object_id]').val();
                d.date_from = $('input[id=date_from]').val();
                d.date_to = $('input[id=date_to]').val();
            }
        },
        "bAutoWidth": false,
        "order": [[7, "desc"]],
        "columns": columns,
        'columnDefs': [
            {
            'targets': [4, 5],
            'className': 'dt-body-center',
            'max-width': '25%',
            'min-width': '20%',
            'render': function (data, type, full, meta) {
                return data;
            }
            },
            {
                'targets': [0, 1, 2, 3, 6, 7],
                'max-width': '15%',
                'min-width': '5%',
            },
        ]
    });

    $('#search-form').on('submit', function (e) {
        $dt.draw();
        e.preventDefault();
    });
});
